import Cookies from 'js-cookie'

const app = {
  state: {
    language: Cookies.get('language') || 'en',
    size: Cookies.get('size') || 'medium',
    device: 'desktop',
    requestLoading: false,
    theme: Cookies.get('theme')
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_SIZE: (state, size) => {
      state.size = size
      Cookies.set('size', size)
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LOADING: (state, boolean) => {
      state.requestLoading = boolean
    },
    SET_THEME: (state, theme) => {
      state.theme = theme
      Cookies.set('theme', theme)
    }
  },
  actions: {
    setLanguage({commit}, language) {
      commit('SET_LANGUAGE', language)
    },
    setSize({commit}, size) {
      commit('SET_SIZE', size)
    },
    toggleDevice({commit}, device) {
      commit('TOGGLE_DEVICE', device)
    },
    SetLoading({commit}, boolean) {
      commit('SET_LOADING', boolean)
    },
    setTheme({commit}, theme) {
      commit('SET_THEME', theme)
    }
  }
}

export default app
